module.exports = __webpack_public_path__ + "static/img/image15.13da64f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image15.png
// module id = V4Rd
// module chunks = 1